export default "__VITE_ASSET__BPrnAOVI__"